// material-ui
import { withStyles } from "@material-ui/core/styles";
// custom
import Table from "components/Table";
import PropTypes from "prop-types";
import React, { Component } from "react";
// styles
import styles from "./styles";

class SkillTagsList extends Component {
  static propTypes = {
    classes: PropTypes.object,
    skillTags: PropTypes.array,
    onSelect: PropTypes.func,
  };

  onSelect(selectedSkillTag) {
    const { onSelect } = this.props;
    this.setState({ selectedSkillTag });
    if (onSelect) {
      onSelect(selectedSkillTag);
    }
  }

  render() {
    const { skillTags } = this.props;

    return (
      <Table
        data={skillTags}
        meta={[
          {
            path: "value",
            title: "Value",
            numeric: false,
          },
        ]}
        title={"SkillTags"}
        onRowSelect={this.onSelect.bind(this)}
      />
    );
  }
}

export default withStyles(styles)(SkillTagsList);
